module.exports = __webpack_public_path__ + "static/media/Download.1553e5f4.svg";